import React, { Component, Fragment } from 'react';
import * as polyline from '@mapbox/polyline';
import { withStyles } from '@material-ui/core/styles';
import RequestsInspector from '../components/RequestsInspector';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import { PaginatedStaticDataTable, VSpacer } from 'sm-react-components';

import * as formatters from '../formatters';
import { default as CustomMap } from '../components/Map';
import Json from '../modals/Json';

const styles = {
    card: {
        marginBottom: '10px'
    }
};

class OptimizerV1Result extends Component {
  state = {
      tab: 0,
      json: undefined,
      routes: [],
      selectedRoute: -1,
      vehicleIds: [],
      missingIds: []
  };

  componentDidMount = () => {
      this.calculateRoutes(this.props.problem, this.props.solution);
  };

  componentDidUpdate = (prevProps, prevState) => {
      if (prevState.tab !== this.state.tab) {
          this.calculateRoutes(this.props.problem, this.props.solution);
      }
  };

  calculateRoutes = (problem, solution) => {
      const { tab } = this.state;
      const services = new Map();
      let npickups = 0;
      problem.services.forEach(service => {
          services.set(service.id, service);
          service.pickups &&
        service.pickups.forEach((pickup, idx) => {
            const id = pickup.id ? pickup.id : `pickup-${service.id}-${idx}`;
            if (pickup.size) {
                services.set(id, pickup);
            } else {
                npickups = service.pickups.length;
                services.set(id, {
                    ...pickup,
                    size: service.size.map(val => val / npickups)
                });
            }
        });
      });
      const missingIds = solution.solution.missing.map(entry => entry.id);
      const vehicleIds = [];
      const routes = solution.solution.routes.map((route, index) => {
          if (
              route.steps.filter(step => step.type !== 'start' && step.type !== 'end')
                  .length > 0
          ) {
              vehicleIds.push(route.vehicle_id);
          }
          return {
              ...route,
              index,
              steps: route.steps.map(step => ({
                  ...step,
                  ...(services.has(step.id)
                      ? {
                          ...services.get(step.id),
                          location: {
                              ...services.get(step.id).location,
                              label: step.id
                          }
                      }
                      : {})
              })),
              path:
          route.geometry !== undefined
              ? polyline
                  .decode(route.geometry)
                  .map(c => ({ lat: c[0], lng: c[1] }))
              : undefined
          };
      });
      const selectedRoute = routes.length === 1 ? 0 : tab - 1;

      if (selectedRoute >= 0) {
          const stopsWithPickups = {};
          const stopsWithoutPickups = {};
          routes[selectedRoute].steps.forEach(step => {
              if (step.type === 'stop' && step.hasOwnProperty('pickups')) {
                  const npickups = step.pickups.length;
                  step.pickups.forEach((pickup, idx) => {
                      if (pickup.hasOwnProperty('size')) {
                          stopsWithPickups[pickup.id || `pickup-${step.id}-${idx}`] =
                pickup.size;
                      } else {
                          stopsWithPickups[
                              pickup.id || `pickup-${step.id}-${idx}`
                          ] = step.size.map(x => x / npickups);
                      }
                  });
              } else if (step.type === 'stop') {
                  stopsWithoutPickups[step.id] = step.size;
              }
          });
          const vehicle = problem.vehicles.filter(
              vehicle => vehicle.id === routes[selectedRoute].vehicle_id
          )[0];
          let sizes = vehicle.capacity ? vehicle.capacity.map(() => 0) : [];
          Object.values(stopsWithoutPickups).forEach(sizing => {
              if (sizes.length === 0) {
                  sizes = sizing || [];
              } else {
                  sizes = sizes.map((size, idx) => size + sizing[idx]);
              }
          });
          routes[selectedRoute].steps.map(step => {
              const stepToCalc = step;
              let type = 'equal';
              let differences = [];
              if (step.type === 'pickup') {
                  if (sizes.length === 0) {
                      sizes = stopsWithPickups[step.id] || [];
                      differences = stopsWithPickups[step.id] || [];
                  } else {
                      sizes = sizes.map(
                          (size, idx) =>
                              size +
                (stopsWithPickups[step.id] ? stopsWithPickups[step.id][idx] : 0)
                      );
                      differences = stopsWithPickups[step.id];
                  }
                  if (differences !== undefined) {
                      type = 'plus';
                  }
              } else if (step.type === 'stop') {
                  sizes = sizes.map((size, idx) => size - step.size[idx]);
                  differences = step.size;
                  type = 'less';
              } else if (step.type === 'end') {
                  differences = step.size;
              } else if (step.type === 'start') {
                  type =
            Object.entries(stopsWithoutPickups).length === 0 ? 'equal' : 'plus';
                  differences = sizes;
              }

              if (sizes !== undefined && sizes.length > 0) {
                  stepToCalc.size = sizes;
                  stepToCalc.proportion = sizes.map((size, idx) =>
                      parseInt((size / vehicle.capacity[idx]) * 100)
                  );
                  stepToCalc.difference = { type, valor: differences };
              }
              return stepToCalc;
          });
      }
      this.setState({
          routes,
          selectedRoute,
          vehicleIds,
          missingIds
      });
  };

  handleTabChange = (event, value) => {
      this.setState({
          tab: value
      });
  };

  showJSON = (data, title) => {
      this.setState({ json: { data, title } });
  };

  closeJSON = () => {
      this.setState({ json: undefined });
  };

  render() {
      const {
          tab,
          json,
          routes,
          selectedRoute,
          vehicleIds,
          missingIds
      } = this.state;
      const { problem, solution, details } = this.props;
      return (
          <div style={{ maxWidth: '80vw' }}>
              {json && (
                  <Json
                      open={json !== undefined}
                      data={json.data}
                      title={json.title}
                      onClose={this.closeJSON}
                  />
              )}
              <Typography variant="h5">Routes</Typography>
              {routes.length === 0 && <div>No routes</div>}
              {details && (
                  <Fragment>
                      <Tabs
                          value={tab}
                          onChange={this.handleTabChange}
                          indicatorColor="primary"
                          textColor="primary"
                          variant={routes.length > 0 ? 'scrollable' : 'standard'}
                          scrollButtons="auto"
                      >
                          {routes.length > 1 && <Tab label="All" key="All" />}
                          {solution.solution.routes.map((route, index) => {
                              return (
                                  <Tab
                                      key={index}
                                      label={`${route.vehicle_id} (${route.steps.length - 2})`}
                                  />
                              );
                          })}
                      </Tabs>
                      {selectedRoute >= 0 && (
                          <Fragment>
                              {
                                  <RequestsInspector
                                      type="route"
                                      data={{
                                          ...solution.solution.routes[selectedRoute],
                                          distance: solution.solution.routes[
                                              selectedRoute
                                          ].steps.reduce(
                                              (prev, next) =>
                                                  prev + (next.distance ? next.distance : 0),
                                              0
                                          )
                                      }}
                                  />
                              }

                              <PaginatedStaticDataTable
                                  docs={routes[selectedRoute].steps}
                                  mapping={[
                                      { column: 'id', name: 'Id', sortable: true },
                                      {
                                          column: 'location',
                                          name: 'Location',
                                          formatter: formatters.coordinate
                                      },
                                      {
                                          column: 'arr_time',
                                          name: 'Stop time',
                                          formatter: formatters.stopTime,
                                          sortable: true,
                                          computed: doc => ({
                                              arrival: doc.arr_time,
                                              departure: doc.dep_time
                                          })
                                      },
                                      {
                                          column: 'duration',
                                          name: 'Duration',
                                          formatter: formatters.timeSeconds,
                                          sortable: true
                                      },
                                      {
                                          column: 'distance',
                                          name: 'Distance',
                                          formatter: formatters.distance,
                                          sortable: true
                                      },
                                      {
                                          column: 'size',
                                          name: 'Load (%)',
                                          formatter: formatters.sizesWithPercentages,
                                          sortable: true,
                                          computed: doc => ({
                                              sizes: doc.size,
                                              percentage: doc.proportion
                                          })
                                      },
                                      {
                                          column: 'difference',
                                          name: 'Change',
                                          formatter: formatters.difference,
                                          computed: doc => ({ differences: doc.difference })
                                      }
                                  ]}
                                  search="live"
                                  tableActions={[
                                      {
                                          label: 'JSON',
                                          actionCallback: () =>
                                              this.showJSON(
                                                  selectedRoute === -1 ? routes : routes[selectedRoute],
                                                  'Routes'
                                              )
                                      }
                                  ]}
                              />
                          </Fragment>
                      )}
                  </Fragment>
              )}
              {routes.length > 0 && selectedRoute >= 0 && (
                  <CustomMap
                      markers={routes[selectedRoute].steps
                          .filter(step => step.location !== undefined)
                          .map(step => ({
                              ...step.location,
                              color: routes[selectedRoute].index
                          }))}
                      paths={
                          routes[selectedRoute].path !== undefined
                              ? [
                                  {
                                      path: routes[selectedRoute].path,
                                      color: routes[selectedRoute].index
                                  }
                              ]
                              : []
                      }
                  />
              )}
              {routes.length > 0 && selectedRoute === -1 && (
                  <CustomMap
                      markers={[]
                          .concat(
                              ...routes.map(route =>
                                  route.steps
                                      .filter(step => step.location !== undefined)
                                      .map(step => ({ ...step.location, color: route.index }))
                              )
                          )
                          .filter(c => c !== undefined)}
                      paths={routes
                          .filter(route => route.path !== undefined)
                          .map(route => ({ path: route.path, color: route.index }))}
                  />
              )}
              {details && (
                  <Fragment>
                      <VSpacer />
                      <PaginatedStaticDataTable
                          docs={problem.vehicles}
                          mapping={[
                              {
                                  column: 'empty',
                                  name: `Empty(${problem.vehicles.length - vehicleIds.length})`,
                                  computed: doc => vehicleIds.indexOf(doc.id) === -1,
                                  sortable: true,
                                  formatter: formatters.booleanWarningIcon
                              },
                              { column: 'id', name: 'Id', sortable: true },
                              {
                                  column: 'start',
                                  name: 'Start',
                                  formatter: formatters.coordinate
                              },
                              {
                                  column: 'end',
                                  name: 'End',
                                  formatter: formatters.coordinate
                              },
                              {
                                  column: 'capacity',
                                  name: 'Capacity',
                                  formatter: formatters.list,
                                  sortable: true
                              },
                              {
                                  column: 'timewindow',
                                  name: 'Time window',
                                  formatter: formatters.timewindow
                              },
                              {
                                  column: 'provides',
                                  name: 'Provides',
                                  formatter: formatters.quotedList
                              }
                          ]}
                          title="Vehicles"
                          search="live"
                          tableActions={[
                              {
                                  label: 'JSON',
                                  actionCallback: () =>
                                      this.showJSON(problem.vehicles, 'Vehicles')
                              }
                          ]}
                      />
                      <VSpacer />
                      <PaginatedStaticDataTable
                          docs={problem.services}
                          mapping={[
                              {
                                  column: 'missing',
                                  name: `Missing(${missingIds.length})`,
                                  computed: doc => missingIds.indexOf(doc.id) >= 0,
                                  sortable: true,
                                  formatter: formatters.booleanWarningIcon
                              },
                              { column: 'id', name: 'Id', sortable: true },
                              {
                                  column: 'location',
                                  name: 'Location',
                                  formatter: formatters.coordinate
                              },
                              {
                                  column: 'duration',
                                  name: 'Duration',
                                  formatter: formatters.duration,
                                  sortable: true
                              },
                              {
                                  column: 'size',
                                  name: 'Size',
                                  formatter: formatters.list,
                                  sortable: true
                              },
                              {
                                  column: 'timewindows',
                                  name: 'Time windows',
                                  formatter: formatters.timewindows
                              },
                              {
                                  column: 'reward',
                                  name: 'Reward',
                                  formatter: formatters.number,
                                  sortable: true
                              },
                              {
                                  column: 'optional',
                                  name: 'Optional',
                                  formatter: formatters.boolean,
                                  sortable: true
                              },
                              {
                                  column: 'requires',
                                  name: 'Requires',
                                  formatter: formatters.quotedList
                              }
                          ]}
                          title="Services"
                          search="live"
                          tableActions={[
                              {
                                  label: 'JSON',
                                  actionCallback: () =>
                                      this.showJSON(problem.services, 'Services')
                              }
                          ]}
                      />
                      <CustomMap
                          markers={problem.services.map(service => ({
                              ...service.location,
                              label: `Id: ${service.id}`
                          }))}
                      />
                  </Fragment>
              )}
          </div>
      );
  }
}

export default withStyles(styles)(OptimizerV1Result);
